import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ListDataColumn } from '../../../shared/ui/Data/ListColumn';
import { AuthService } from '../../../shared/service/auth-service/auth-service.service';

export class FieldDefinitionFields {
  constructor(private injector: Injector) { }

  mahsFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'fieldQueryType',
      props: {
        label: 'MAH Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'country',
      type: 'fieldQueryType',
      props: {
        label: 'Country',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'city',
      type: 'fieldQueryType',
      props: {
        label: 'City',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'address',
      type: 'fieldQueryType',
      props: {
        label: 'Address',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'region',
      type: 'fieldQueryType',
      props: {
        label: 'State',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'organisationsenderid',
      type: 'fieldQueryType',
      props: {
        label: 'MAH Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    }
  ];

  sponsorFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'fieldQueryType',
      props: {
        label: 'Sponsor Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'country',
      type: 'fieldQueryType',
      props: {
        label: 'Country',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'city',
      type: 'fieldQueryType',
      props: {
        label: 'City',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'address',
      type: 'fieldQueryType',
      props: {
        label: 'Address',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'region',
      type: 'fieldQueryType',
      props: {
        label: 'State',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'organisationsenderid',
      type: 'fieldQueryType',
      props: {
        label: 'MAH Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
  ];

  atcCodeFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'atccode',
      type: 'fieldQueryType',
      props: {
        label: 'ATC Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'atccode_Desc',
      type: 'fieldQueryType',
      props: {
        label: 'ATC Code Description',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'type_Term',
      type: 'fieldQueryType',
      props: {
        label: 'Type',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'type_Term',
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'fieldQueryType',
      props: {
        label: 'Version Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.VERSIONDATE,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'deprecated',
      type: 'fieldQueryType',
      props: {
        label: 'Deprecated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'yesNo',
      },
    },
  ];

  sourceFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'sourcename',
      type: 'fieldQueryType',
      props: {
        label: 'Source Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
  ];

  pharmaceuticalFormsFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Pharmform',
      type: 'fieldQueryType',
      props: {
        label: 'Pharmaceutical Form Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'type_Term',
      type: 'fieldQueryType',
      props: {
        label: 'Type',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'type_Term',
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'fieldQueryType',
      props: {
        label: 'Version Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.VERSIONDATE,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'deprecated',
      type: 'fieldQueryType',
      props: {
        label: 'Deprecated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'yesNo',
      },
    },
  ];

  roaFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Admroute',
      type: 'fieldQueryType',
      props: {
        label: 'Administration Route Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'type_Term',
      type: 'fieldQueryType',
      props: {
        label: 'Type',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'type_Term',
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'fieldQueryType',
      props: {
        label: 'Version Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.VERSIONDATE,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'deprecated',
      type: 'fieldQueryType',
      props: {
        label: 'Deprecated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'yesNo',
      },
    },
  ];

  attachmentFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'datesent',
      type: 'fieldQueryType',
      props: {
        label: 'Date Sent',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'filename',
      type: 'fieldQueryType',
      props: {
        label: 'File Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'attachmentname',
      type: 'fieldQueryType',
      props: {
        label: 'Attachment Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'languagecode',
      type: 'fieldQueryType',
      props: {
        label: 'Language',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'language',
      },
    },
    {
      className: 'flex-1',
      key: 'attachmenttype',
      type: 'fieldQueryType',
      props: {
        label: 'Type',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'attachmenttype',
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation()
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
  ];

  mflFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mflcountrycode',
      type: 'fieldQueryType',
      props: {
        label: 'Country',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'country',
      },
    },
    {
      className: 'flex-1',
      key: 'mflcity',
      type: 'fieldQueryType',
      props: {
        label: 'City',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mflstreet',
      type: 'fieldQueryType',
      props: {
        label: 'Street',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mflpostcode',
      type: 'fieldQueryType',
      props: {
        label: 'Postcode',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'datesent',
      type: 'fieldQueryType',
      props: {
        label: 'Date Sent',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'mflcompany',
      type: 'fieldQueryType',
      props: {
        label: 'Company Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mfldepartment',
      type: 'fieldQueryType',
      props: {
        label: 'Department',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mflbuilding',
      type: 'fieldQueryType',
      props: {
        label: 'Building',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mflstate',
      type: 'fieldQueryType',
      props: {
        label: 'State',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    }
  ];

  approvedSubstancesFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'fieldQueryType',
      props: {
        label: 'Substance Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'casnumber',
      type: 'fieldQueryType',
      props: {
        label: 'CAS Number',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'molecularformula',
      type: 'fieldQueryType',
      props: {
        label: 'Molecular Formula',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'sourcename',
      type: 'fieldQueryType',
      props: {
        label: 'Source Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      props: {
        label: 'Owner HQ ID',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    }
  ];

  substancesNamesFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'count',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Count',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'type_substance',
      type: 'fieldQueryType',
      props: {
        label: 'Type',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'substancestypes',
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'substancenames',
      type: 'fieldQueryType',
      props: {
        label: 'Matching Names',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'nameType',
      type: 'fieldQueryType',
      props: {
        label: 'Name Type',
        defaultSelection: false
      },
    },
    {
      className: 'flex-1',
      key: 'checked',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: false,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    }
  ];

  substancesNamesByTypesFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'count',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Count',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'substancenames',
      type: 'fieldQueryType',
      props: {
        label: 'Matching Names',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'nameType',
      type: 'fieldQueryType',
      props: {
        label: 'Name Type',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT
      },
    },
    {
      className: 'flex-1',
      key: 'checked',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: false,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    }
  ];

  developmentSubstancesFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
        required: true,
      },
    },
    {
      className: 'flex-1',
      key: 'lastupdated',
      type: 'fieldQueryType',
      props: {
        label: 'Last Update',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'fieldQueryType',
      props: {
        label: 'Substance Name or Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'iscode',
      type: 'fieldQueryType',
      props: {
        label: 'Is Name or Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'substancenameorcode',
      },
    },
    {
      className: 'flex-1',
      key: 'casnumber',
      type: 'fieldQueryType',
      props: {
        label: 'CAS Number',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'molecularformula',
      type: 'fieldQueryType',
      props: {
        label: 'Molecular Formula',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'fieldQueryType',
      props: {
        label: 'Sponsor Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    /* JMBL this field doesn't exist in OLD Art.57
        {
          className: 'flex-1',
          key: 'country',
          type: 'fieldQueryType',
          props: {
            label: 'Country',
            defaultSelection: true,
            fieldDataType: ListDataColumn.TEXT,
          },
        },
    */
    {
      className: 'flex-1',
      key: 'organisation_ev_code',
      type: 'fieldQueryType',
      props: {
        label: 'Sponsor Code',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'validated',
      type: 'fieldQueryType',
      props: {
        label: 'Validated',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'stamp_nullif',
      type: 'fieldQueryType',
      props: {
        label: 'Nullified',
        defaultSelection: true,
        fieldDataType: ListDataColumn.YESNODATETIME,
      },
    },
  ];

  authorisedProductsFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'version',
      type: 'fieldQueryType',
      props: {
        label: 'Version',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'fieldQueryType',
      props: {
        label: 'Version Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'art57',
      type: 'fieldQueryType',
      props: {
        label: 'Article 57 Format',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'art57Format',
      },
    },
    {
      className: 'flex-1',
      key: 'is_transition',
      type: 'fieldQueryType',
      props: {
        label: 'Interim Format',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'interimFormat',
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAorNCAOrganisation();
      },
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'ownername',
      type: 'fieldQueryType',
      props: {
        label: 'Owner Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productname',
      type: 'fieldQueryType',
      props: {
        label: 'Full Presentation Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productshortname',
      type: 'fieldQueryType',
      props: {
        label: 'Product Short Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productgenericname',
      type: 'fieldQueryType',
      props: {
        label: 'Product INN/Common Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productstrength',
      type: 'fieldQueryType',
      props: {
        label: 'Product Strength Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productcompanyname',
      type: 'fieldQueryType',
      props: {
        label: 'Product Company Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productform',
      type: 'fieldQueryType',
      props: {
        label: 'Product Form Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'packagedesc',
      type: 'fieldQueryType',
      props: {
        label: 'Package Description',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationcountrycode',
      type: 'fieldQueryType',
      props: {
        label: 'Authorisation Country',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'country'
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationprocedure',
      type: 'fieldQueryType',
      props: {
        label: 'Authorisation Procedure',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'authorisationprocedure'
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationstatus',
      type: 'fieldQueryType',
      props: {
        label: 'Authorisation Status',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'authorisationstatus'
      },
    },
    {
      className: 'flex-1',
      key: 'ma_valid',
      type: 'fieldQueryType',
      props: {
        label: 'MA Validity',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'validityFormat',
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Authorisation Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'authorisationdate',
      type: 'fieldQueryType',
      props: {
        label: 'Authorisation/Renewal Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.VERSIONDATE,
      },
    },
    {
      className: 'flex-1',
      key: 'mrpnumber',
      type: 'fieldQueryType',
      props: {
        label: 'MRP/DCP/EMEA Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'eunumber',
      type: 'fieldQueryType',
      props: {
        label: 'EU Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'legal_basis',
      type: 'fieldQueryType',
      props: {
        label: 'Legal Basis',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'legalbasis'
      },
    },
    {
      className: 'flex-1',
      key: 'withdrawndate',
      type: 'fieldQueryType',
      props: {
        label: 'Invalidated Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATE,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'fieldQueryType',
      props: {
        label: 'MAH Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'organisation_ev_code',
      type: 'fieldQueryType',
      props: {
        label: 'MAH Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'qppv',
      type: 'fieldQueryType',
      props: {
        label: 'QPPV',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'mfl',
      type: 'fieldQueryType',
      props: {
        label: 'Master File Location',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Pharmform',
      type: 'fieldQueryType',
      props: {
        label: 'Pharmaceutical Form',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Admroute',
      type: 'fieldQueryType',
      props: {
        label: 'Route of Administration',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'fieldQueryType',
      props: {
        label: 'Substance names',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'english',
      type: 'fieldQueryType',
      props: {
        label: 'Substance Amount Value Types',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'attachmentevcode',
      type: 'fieldQueryType',
      props: {
        label: 'Attachment EV Code(s)',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'is_nullable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Nullifiable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'product_validity',
      type: 'fieldQueryType',
      props: {
        label: 'Product Validity',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'validityValues',
      },
    },
    {
      className: 'flex-1',
      key: 'product_pending',
      type: 'fieldQueryType',
      props: {
        label: 'Product Pending',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'pendingValues',
      },
    },
    {
      className: 'flex-1',
      key: 'product_nullified',
      type: 'fieldQueryType',
      props: {
        label: 'Product Nullified',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'product_last_rejected',
      type: 'fieldQueryType',
      props: {
        label: 'Product Last Reject',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
  ];

  developmentProductsFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      props: {
        label: 'Local Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
    },
    {
      className: 'flex-1',
      key: 'ev_Code',
      type: 'fieldQueryType',
      props: {
        label: 'EV Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'version',
      type: 'fieldQueryType',
      props: {
        label: 'Version',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'versiondate',
      type: 'fieldQueryType',
      props: {
        label: 'Version Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      props: {
        label: 'Owner HQ ID',
        defaultSelection: this.injector.get(AuthService).isEMAorNCAOrganisation(),
        fieldDataType: ListDataColumn.TEXT,
        readonly: !this.injector.get(AuthService).isEMAorNCAOrganisation(),
      },
    },
    {
      className: 'flex-1',
      key: 'productname',
      type: 'fieldQueryType',
      props: {
        label: 'Full Presentation Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productcode',
      type: 'fieldQueryType',
      props: {
        label: 'Product Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'productothername',
      type: 'fieldQueryType',
      props: {
        label: 'Product Other Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Org',
      type: 'fieldQueryType',
      props: {
        label: 'Sponsor Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'organisation_ev_code',
      type: 'fieldQueryType',
      props: {
        label: 'Sponsor Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Pharmform',
      type: 'fieldQueryType',
      props: {
        label: 'Pharmaceutical Form',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'name_Admroute',
      type: 'fieldQueryType',
      props: {
        label: 'Route of Administration',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'substancename',
      type: 'fieldQueryType',
      props: {
        label: 'Substance names',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'english',
      type: 'fieldQueryType',
      props: {
        label: 'Substance Amount Value Types',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'attachmentevcode',
      type: 'fieldQueryType',
      props: {
        label: 'Attachment EV Code(s)',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_updatable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Updatable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'is_nullable',
      type: 'fieldQueryType',
      props: {
        label: 'Is Nullifiable',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
    {
      className: 'flex-1',
      key: 'ownername',
      type: 'fieldQueryType',
      props: {
        label: 'Owner Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: false,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'product_validity',
      type: 'fieldQueryType',
      props: {
        label: 'Product Validity',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'validityValues',
      },
    },
    {
      className: 'flex-1',
      key: 'product_pending',
      type: 'fieldQueryType',
      props: {
        label: 'Product Pending',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'pendingValues',
      },
    },
    {
      className: 'flex-1',
      key: 'product_nullified',
      type: 'fieldQueryType',
      props: {
        label: 'Product Nullified',
        defaultSelection: false,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'binaryYesNo',
      },
    },
  ];

  abstractCompositionFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'scientificname',
      type: 'fieldQueryType',
      props: {
        label: 'Scientific Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'scientificcode',
      type: 'fieldQueryType',
      props: {
        label: 'Scientific Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'ownerhqid',
      type: 'fieldQueryType',
      props: {
        label: 'Owner HQ ID',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'is_development',
      type: 'fieldQueryType',
      props: {
        label: 'Type',
        defaultSelection: true,
        fieldDataType: ListDataColumn.LOOKUP,
        lookup: 'substancestypes',
      },
    },
  ];

  xevprmMessageFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'localnumber',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Local Message Number',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER,
      },
    },
    {
      className: 'flex-1',
      key: 'messagenumber',
      type: 'fieldQueryType',
      props: {
        label: 'Message Number',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'senderid',
      type: 'fieldQueryType',
      props: {
        label: 'Sender ID',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'sendername',
      type: 'fieldQueryType',
      props: {
        label: 'Sender Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT,
      },
    },
    {
      className: 'flex-1',
      key: 'messagedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'messagereceivedate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Receive Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.DATETIME,
      },
    },
    {
      className: 'flex-1',
      key: 'ackdate',
      type: 'fieldQueryType',
      props: {
        label: 'Message Ack Date',
        defaultSelection: true,
        fieldDataType: ListDataColumn.DATETIME,
      },
    }
  ]

}


